import React from 'react';
import { adminRoute } from '@/modules/administration/routes';
import { createRoute } from '@tanstack/react-router';

export const fleetManagementRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'fleet-management',
  wrapInSuspense: true,
  component: React.lazy(async () => await import('@/app/routes/Admin/AdminFleet')),
});
